import { bool, func } from 'prop-types'

import IconButton from '../../theme-components/icon-button.js'

function DesktopCarouselControl({ backgroundIsDark = false, leftFunc, rightFunc }) {
  // @todo: this should probably correspond to the post color and match that instead
  const buttonStyles = {
    background: backgroundIsDark ? '#fff' : '#333',
    userSelect: 'none',
  }

  // @todo: this should probably correspond to the post color and match that instead
  const arrowColor = backgroundIsDark ? '#333' : '#fff'

  return (
    <div className="bzfy-c-carousel-control-wrapper">
      <IconButton
        ariaLabel="previous"
        className="bzfy-c-carousel-control"
        iconColor={arrowColor}
        iconName="arrow-left"
        onClick={leftFunc}
        style={buttonStyles}
      />
      <IconButton
        ariaLabel="next"
        className="bzfy-c-carousel-control bzfy-c-carousel-control--right"
        iconColor={arrowColor}
        iconName="arrow-right"
        onClick={rightFunc}
        style={buttonStyles}
      />
    </div>
  )
}

DesktopCarouselControl.propTypes = {
  backgroundIsDark: bool,
  leftFunc: func.isRequired,
  rightFunc: func.isRequired,
}

export default DesktopCarouselControl
